import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_LIST_BY_RESERVATION_ID_FOR_MANAGEMENT_RESERVATION_SEARCH_QUERY = graphql(/* GraphQL */ `
	query ReservationListByReservationIDForManagementReservationSearch($hotelID: ID!, $reservationId: ID!) {
		reservationListByReservationID(hotelID: $hotelID, reservationID: $reservationId) {
			id
			hotelID
			hotelPrefecture
			hotelName
			reservations {
				hotelID
				reservationID
				reservationType
				repeaterType
				reservationStatus
				guestName
				guestNameKana
				guestTel
				guestEmail
				guestPostalCode
				guestAddress
				checkIn
				checkInTimeStart
				checkInTimeEnd
				checkOut
				reserveDate
				latestUpdateDate
				canceledDate
				numOfPeople
				numOfAdult
				numOfKids
				numOfRoom
				plan
				planCanceled
				room {
					roomID
					name
					date
					numOfPeople {
						adultNum
						kidsNum {
							age
							asCosleeping
						}
						uniqueRoomID
					}
				}
				roomCanceled {
					roomID
					name
					date
					numOfPeople {
						adultNum
						kidsNum {
							age
							asCosleeping
						}
						uniqueRoomID
					}
				}
				option {
					optionID
					name
					date
					amount
				}
				optionCanceled {
					optionID
					name
					date
					amount
				}
				discount
				questions {
					question
					answer
				}
				vouchers {
					name
					price
				}
				paymentMethod
				totalGuestCharge
				pricePlanTotal
				priceRoomTotal
				priceOptionTotal
				priceAdditionalFeeTotal
				priceDiscount
				isAcceptMailMagazine
				isNoShow
				memoByHost
				createdAt
			}
		}
	}
`);
